<template>
    <div class="amount_card" :class="isActiveAmount ? 'active_card' : ''" @click="handleCardClick">
           {{ formatCurrency(props.amount as any) }}
        <div v-if="isTopupVisible" class="topPercentage" :class="isActiveAmount ? 'activeLabel' : 'inactiveLabel'">
            <span class="item-span">{{ props.giftRatio }}%</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction';


const props = defineProps({
    amount: {
        type: Number,
    },
    isActiveAmount: {
        type: Boolean,
        default: () => false
    },
    isTopupVisible: {
        type: Boolean,
        default: () => false
    },
    giftRatio: {
        type: Number,
    }
})
const emits = defineEmits(['handleCardClick'])

const handleCardClick = () => {
    emits('handleCardClick')
}

</script>
<style scoped>
.amount_card {
    position: relative;
    border-radius: 5px;
    color: #656F85;
    background-color: #1A223A;
    padding: 12px 10px;
    min-width: 80px;     
    flex: 0 0 auto;
    text-align: center;
    font-size: 18px;
    overflow: hidden;
}

.active_card {
    font-weight: bold;
    border: 2px solid #046ACC;
    background-image: linear-gradient(180deg, #1F283F 0%, #141B2D 100%);
    color: #FFFF;

}

.activeLabel {
    background: #046ACC;
    color: #FFFF;
    font-weight: 600;
}

.inactiveLabel {
    background: rgba(0, 0, 0, 0.15);
    color: rgba(255, 255, 255, 0.85);
}

.topPercentage {
    position: absolute;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 24px;
    top: -1px;
    right: -27px;
    transform: rotate(45deg);
    font-size: 9px;
}

@media (max-width: 360px) {
  .amount_card {
    padding: 8px 6px;
    font-size: 14px;
    min-width: unset;
    border-radius: 4px;
  }

  .active_card {
    border-width: 1.5px;
  }

  .topPercentage {
    width: 50px;
    height: 18px;
    right: -19px;
    font-size: 8px;
  }

  
}

.item-span {
    top: 10px;
    left: 1px;
}
</style>